import { UserWsMessage, UserWsMessageSubject } from '@cibo/core'
import { createContext } from 'react'

export type MessagesBySubject = Partial<Record<UserWsMessageSubject, UserWsMessage>>

export type UserWebSocketContextValue = {
  connected: boolean
  error?: Error
  lastMessage?: UserWsMessage
  messagesBySubject: MessagesBySubject
}

export const UserWebSocketContext = createContext<UserWebSocketContextValue>({
  connected: false,
  messagesBySubject: {},
})
UserWebSocketContext.displayName = 'UserWebSocketContext'
